export const loadingActionTypes = {
	LOADING: "LOADING",
	TOGGLE_AUTH_MODAL: 'TOGGLE_AUTH_MODAL'
};
